module.exports = __webpack_public_path__ + "img/banner.d1698b49.png";